import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { CompanyService } from '@shared/http/company.service';
import { FileStorageService } from '@shared/http/file-storage.service';
import { TicketService } from '@shared/http/ticket.service';
import { SFCompany } from '@shared/models/Company';
import { ToastService } from '@shared/services/toast.service';
import { finalize, take } from 'rxjs/operators';
import { User } from '@shared/models/User';
import { TimeUtils } from '@shared/utils/time.utils';
import { TicketType } from '@app/websocket/models/TicketType';
import { FeatureFlagService } from '@shared/services/feature-flag.service';

@Component({
    selector: 'app-create-ticket-dialog',
    templateUrl: './create-ticket-dialog.component.html',
    styleUrls: ['./create-ticket-dialog.component.scss']
})
export class CreateTicketDialogComponent implements OnInit {
    public isConfirming = false;
    public isUploading = false;

    public link: string;
    public description = new FormControl();

    public readonly limit = 3000;

    public company: SFCompany;

    public canSelectCompany = false;
    public message = '';
    public product = '';
    public type = 'Dúvida';
    public problemType = "sua dúvida";

    public user: User = User.fromLocalStorage();
    public hasBuscaExtrato = this.user.hasBuscaExtrato;
    public hasIntegrador = this.user.hasIntegrador;
    public hasTareffa = this.user.hasTareffa;
    public hasAtendimentoCliente = this.user.hasAtendimentoCliente;

    constructor(
        public dialogRef: MatDialogRef<CreateTicketDialogComponent>,
        private fileStorageService: FileStorageService,
        private ticketService: TicketService,
        private toast: ToastService,
        private companyService: CompanyService,
        private ff: FeatureFlagService
    ) { }

    ngOnInit(): void {
    }

    public openTutorial() {
        // window.open(environment.urlDocumentationTickets, '_blank');
    }

    public async upload(file: File) {
        if (this.isUploading || this.isConfirming) {
            return;
        }
        this.isUploading = true;
        if (!this.canSelectCompany) {
            try {
                const response = await this.companyService.fetch({ CNPJ__c: '00.000.000/0000-00', pageSize: 1 }).toPromise();
                this.company = response.records[0];
            } catch (error) {
                this.toast.showSnack('Não foi possível encontrar empresas, tente novamente mais tarde. Se o problema persistir, entre em contato com o suporte Ottimizza.');
                console.error('Erro ao buscar empresa:', error);
                return;
            }
        }

        this.fileStorageService.storeInS3(file, file.name)
            .pipe(finalize(() => this.isUploading = false))
            .subscribe((fileId: any) => {
                this.link = this.fileStorageService.getResourceURLS3(fileId.uuid);
            });
    }

    public async confirm() {
        if (!this.message || !this.product || this.isConfirming || this.isUploading) {
            return;
        }
        if (!this.canSelectCompany) {
            try {
                const response = await this.companyService.fetch({ CNPJ__c: '00.000.000/0000-00', pageSize: 1 }).toPromise();
                this.company = response.records[0];
            } catch (error) {
                this.toast.showSnack('Erro ao buscar empresa. Tente novamente mais tarde.');
                console.error('Erro ao buscar empresa:', error);
            }
        }

        this.isConfirming = true;

        this.ticketService.create(this.company.Contabilidade__c, this.company.Id, this.message, this.product, this.type, this.link || undefined)
            .pipe(finalize(() => this.isConfirming = false))
            .subscribe(async () => {
                const company = this.company;
                this.company = null;
                await TimeUtils.sleep(100);
                this.company = company;
                this.message = '';
                this.link = undefined;

                this.toast.show('Chamado aberto com sucesso!');
                this.dialogRef.close(true);
            });
    }

    public onProductChanged(e: any) {
        e.preventDefault();
        if (e.target.value === 'Tareffa' || e.target.value === 'Atendimento ao Cliente') {
            this.canSelectCompany = false;
        } else {
            this.canSelectCompany = true;
        }

    }

    public onTypeChanged(e: any) {
        e.preventDefault();
        switch (e.target.value) {
            case TicketType.DUVIDA:
                this.problemType = 'sua dúvida';
                break;
            case TicketType.BUGFIX_lower:
                this.problemType = 'seu problema';
                break;
            case TicketType.BUGFIX_upper:
                this.problemType = 'seu problema';
                break;
            case TicketType.MELHORIA:
                this.problemType = 'sua sugestão';
                break;
            case TicketType.MAPEAMENTO_PLANILHA:
                this.problemType = 'sobre o mapeamento';
                break;
        }
    }

}
